const dialogActions = {
	SET_DIALOGS_OPEN: 'SET_DIALOGS_OPEN',
	open: ({
		title,
		content,
		dialogProps,
		color,
		contentKey,
		contentProps,
		dismissible,
	}) => ({
		type: dialogActions.SET_DIALOGS_OPEN,
		content,
		title,
		dialogProps,
		color,
		contentKey,
		contentProps,
		dismissible,
	}),
	SET_DIALOGS_CLOSE: 'SET_DIALOGS_CLOSE',
	close: () => ({
		type: dialogActions.SET_DIALOGS_CLOSE,
	}),
	DIALOGS_SET_TITLE: 'DIALOGS_SET_TITLE',
	setTitle: (title) => ({
		type: dialogActions.DIALOGS_SET_TITLE,
		title,
	}),
	DIALOGS_SET_CONTENT: 'DIALOGS_SET_CONTENT',
	setContent: (content) => ({
		type: dialogActions.DIALOGS_SET_CONTENT,
		content,
	}),
	DIALOGS_RESET: 'DIALOGS_RESET',
	reset: () => ({
		type: dialogActions.DIALOGS_RESET,
	}),
};

export default dialogActions;
